import styled from '@emotion/styled';

export const SContainer = styled.section`
  display: flex;
  flex-direction: column;
`;

export const SFooterInner = styled.div`
  display: flex;
  justify-content: space-between;
`;
